import { render } from "./requisitesAbout.vue?vue&type=template&id=5abeee2e&scoped=true"
import script from "./requisitesAbout.vue?vue&type=script&lang=js"
export * from "./requisitesAbout.vue?vue&type=script&lang=js"

import "./requisitesAbout.vue?vue&type=style&index=0&id=5abeee2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abeee2e"]])

export default __exports__